import { jsx as l } from "react/jsx-runtime";
import { useState as c, useEffect as m } from "react";
import p from "./index.es5742.js";
import { noop as d } from "lodash/fp";
import { LoadingBar as i } from "./index.es63.js";
const x = ({ isError: e, onFinishedUpload: r = d }) => {
  const [o, a] = c(0);
  return m(() => {
    let t = 0;
    const s = setInterval(() => {
      t < 100 && !e ? (a((n) => n + 0.25), t += 0.25) : (clearInterval(s), r());
    }, 10);
    return () => {
      clearInterval(s);
    };
  }, [e, r]), o < 100 ? /* @__PURE__ */ l("div", { className: p["loader-container"], children: /* @__PURE__ */ l(
    i,
    {
      mode: "progress",
      progress: o,
      status: e ? "error" : "loading"
    }
  ) }) : null;
};
export {
  x as FileUploadLoader
};
//# sourceMappingURL=index.es5605.js.map
